module.exports = __webpack_public_path__ + "img/sign-11.9135168f.jpg";